interface PasswordValidatorSourceObj {
  id: string;
  label: string;
  pattern: RegExp;
  valid: boolean;
}

export const passwordValidatorSource: PasswordValidatorSourceObj[] = [
  {
    id: 'minimum8Characters',
    label: 'Minimum 8 characters',
    pattern: /^.{8,}$/,
    valid: false,
  },
  {
    id: 'uppercaseCharacter',
    label: 'At least upper case character (A-Z)',
    pattern: /(?=.*[A-Z])/,
    valid: false,
  },
  {
    id: 'digitOrSpecialCharacter',
    label: 'One number or special character (0-9 or !@#)',
    pattern: /(?=.*[\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/,
    valid: false,
  },
];

const passwordValidator = (password: string): PasswordValidatorSourceObj[] => {
  const result = passwordValidatorSource.map(item => ({
    ...item,
    valid: !!password.match(item.pattern),
  }));

  return result;
};

export default passwordValidator;
